import { useTranslation } from 'react-i18next';

import { ChargebackReason } from '../../Shared/types';

interface ChargebackReasonLabelProps {
  reason: ChargebackReason;
}

export default function ChargebackReasonLabel({ reason }: ChargebackReasonLabelProps) {
  const { t } = useTranslation();

  return (
    <span className="font-medium text-red-600">
      {t(`shared:chargeback_reason.${reason}`)}
    </span>
  );
}
